<div class="logout-popup">
    <div class="content">
        <div class="logo-text">
            <div class="logo-container">
                <img src="assets/icons/logo.png" alt="Vector Logo" class="vector" />
            </div>
            <p class="logout">your account will be deleted within 7 business days.</p>
            <p class="sub-text">thanks for sharing your time with showlab.</p>
        </div>
    </div>